import { SpaProductAgeRestrictionDTO } from '@api';

export function parseAgeRestriction(restriction: SpaProductAgeRestrictionDTO): { minAge?: number; maxAge?: number } {
  switch (restriction) {
    case SpaProductAgeRestrictionDTO.FROM_12_TO_16:
      return { minAge: 12, maxAge: 15 };
    case SpaProductAgeRestrictionDTO.FROM_13_TO_INCLUDING_16:
      return { minAge: 13, maxAge: 16 };
    case SpaProductAgeRestrictionDTO.FROM_16:
      return { minAge: 16 };
    case SpaProductAgeRestrictionDTO.TO_INCLUDING_12:
      return { maxAge: 12 };
    case SpaProductAgeRestrictionDTO.TO_16:
      return { maxAge: 15 };
    case SpaProductAgeRestrictionDTO.NONE:
      return {};
    default: {
      const exhaustiveCheck: never = restriction;
      console.warn(`Unhandled age restriction: ${exhaustiveCheck}`);
      return {};
    }
  }
}
